module.exports = __webpack_public_path__ + "assets/img/37_1421_big.06235be8.jpg";